import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { Observable } from 'rxjs';
import { TitleseoService } from './titleseo.service';

@Injectable({
  providedIn: 'root',
})
export class TitleSeoResolver implements Resolve<Entry<any>[]> {
  constructor(private titleSeoService: TitleseoService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    return this.titleSeoService.getSeoData(
      route.data?.['params']?.contentType,
      route.data?.['params']?.fieldsId
    );
  }
}
